import { gql } from '@apollo/client';

export default gql`
  query places($page: Int, $name: String, $sortBy: String, $search: String, $bucket: String) {
    space {
      overPlacesLimit
      adminRole
    }
    places(page: $page, name: $name, sortBy: $sortBy, search: $search, bucket: $bucket) {
      placesTotalPages
      placesTotal
      perPage
      hasNextPage
      places {
        id
        name
        street
        zipCode
        city
        phone
        email
        inspectionSubjectsTotal
        inspectionsTotal
        incomingInspectionsTotal
        overdueInspectionsTotal
        createdAt
        updatedAt
      }
    }
  }
`;
